import React, { useRef } from 'react';

interface ModalProps {
  show: boolean;
  classes?: string;
  children: React.ReactNode;
  width?: string;
  height?: string;
  posX?: string;
  posY?: string;
  closeHandler: () => void;
  titel: string;
  description?: string;
  closeByOutsideClick?: boolean;
  withoutHeader?: boolean;
}

const posXDefault = '50%';
const posYDefault = '50%';
const closeByOutsideClick = true;

/**
 * Modal-Component
 * Dient zur Erzeugung von einem modalen Fenster.
 *
 * @returns {JSX.Element} Modal-Component
 * @constructor
 */

const Modal = (props: ModalProps) => {
  const configStyle = {
    width: props.width ?? '',
    height: props.height ?? '',
    top: props.posY ?? posYDefault,
    left: props.posX ?? posXDefault,
  };

  const modalContainer = useRef(null);

  if (props.show) {
    document.body.classList.add('modal-active');
    return (
      <div
        ref={modalContainer}
        className={`modal-container ${props.classes ? props.classes : ''}`}
        onClick={e => {
          if (
            (props.closeByOutsideClick ?? closeByOutsideClick) &&
            e.target === modalContainer.current
          ) {
            props.closeHandler();
          }
        }}
      >
        <div
          className={'modal-content ' + props.classes ?? ''}
          style={configStyle}
        >
          {!props.withoutHeader && (
            <div>
              <div className='modal-header'>
                <h3 className='modal-title'>{props.titel}</h3>
              </div>
              <button
                className='modal-close'
                onClick={props.closeHandler}
                title={'Fenster schließen'}
              >
                <i className='far fa-times-circle' />
              </button>
            </div>
          )}
          {props.description && (
            <div className='modal-description'>{props.description}</div>
          )}
          <div className='modal-body'>{props.children}</div>
        </div>
      </div>
    );
  } else {
    document.body.classList.remove('modal-active');
    return null;
  }
};

export default Modal;
